import { FC, lazy, Suspense } from "react";

const HeaderDefault = lazy(() => import("./HeaderDefault"));
const HeaderWithLogout = lazy(() => import("./HeaderWithLogout"));

interface HeaderProps {
    headerType: string;
    displayLogout: boolean
}

const Header: FC<HeaderProps> = ({ headerType, displayLogout }) => {
    if (displayLogout)
        return (
            <Suspense fallback={<div>Loading...</div>}>
                <HeaderWithLogout headerType={headerType} />
            </Suspense>
        );
    else
        return (
            <Suspense fallback={<div>Loading...</div>}>
                <HeaderDefault headerType={headerType} />
            </Suspense>
        );
}

export default Header;